import formatDate from './../utils/formatDate';
import { apiFetch } from './apiFetch';

const recordService = {
  async getRecords(groupId, filters = {}) {
    const url = `${process.env.REACT_APP_API_URL}/Record`;
    const formData = new FormData();
    
    function mergeDateAndTime(date, time) {
      const merged = new Date(date);
      if (time) {
        const timeDate = new Date(time);
        merged.setHours(timeDate.getHours(), timeDate.getMinutes(), timeDate.getSeconds() || 0, timeDate.getMilliseconds() || 0);
      }
      return merged;
    }

    formData.append('GroupId', groupId || 0);
    formData.append('VisorRef', filters.visorRef || '');
    formData.append('ReviewedBy', filters.analystUsername || '');

    if (filters.dateRange?.[0]?.startDate) {
  const fromDateTime = mergeDateAndTime(filters.dateRange[0].startDate, filters.startTime);
  formData.append('FromDate', formatDate(fromDateTime));
}

if (filters.dateRange?.[0]?.endDate) {
  const toDateTime = mergeDateAndTime(filters.dateRange[0].endDate, filters.endTime);
  formData.append('ToDate', formatDate(toDateTime));
}
formData.append('Positive', filters.positive != null ? String(filters.positive) : '0');
    formData.append('Quarantine', filters.quarantine != null ? String(filters.quarantine) : '0');
    formData.append('Status', filters.status != null ? String(filters.status) : '2');
    formData.append('Action', filters.action != null ? String(filters.action) : '0');
    formData.append('SortColumn', filters.SortColumn || 0);
    formData.append('SortAsc', filters.SortAsc || false);
    formData.append('PageSize', filters.pageSize || 20);
    formData.append('PageIndex', filters.pageIndex || 1);

    const response = await apiFetch(url, {
      method: 'POST',     
      credentials: 'include',
      body: formData,
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }
    return await response.json();
  },

  async getRecordsTable(groupId, filters = {}, signal) {
    const url = `${process.env.REACT_APP_API_URL}/Record/Table`;
    const formData = new FormData();
    
    formData.append('GroupId', groupId || 0);
    formData.append('VisorRef', filters.visorRef || '');

    // Merge dateRange with startTime
if (filters.dateRange?.[0]?.startDate) {
  const fromDate = new Date(filters.dateRange[0].startDate);
  if (filters.startTime) {
    const t = new Date(filters.startTime);
    fromDate.setHours(t.getHours(), t.getMinutes(), t.getSeconds() || 0, t.getMilliseconds() || 0);
  }
  formData.append('FromDate', formatDate(fromDate));
}

// Merge dateRange with endTime
if (filters.dateRange?.[0]?.endDate) {
  const toDate = new Date(filters.dateRange[0].endDate);
  if (filters.endTime) {
    const t = new Date(filters.endTime);
    toDate.setHours(t.getHours(), t.getMinutes(), t.getSeconds() || 0, t.getMilliseconds() || 0);
  }
  formData.append('ToDate', formatDate(toDate));
}

    formData.append('Positive', filters.positive != null ? String(filters.positive) : '0');
    formData.append('Quarantine', filters.quarantine != null ? String(filters.quarantine) : '0');
    formData.append('Status', filters.status != null ? String(filters.status) : '2');
    formData.append('Action', filters.action != null ? String(filters.action) : '0');
    formData.append('SortColumn', filters.sortColumn ?? 1);
    formData.append('SortAsc', filters.sortAsc ?? false);    
    formData.append('PageSize', filters.pageSize || 10);
    formData.append('PageIndex', filters.pageIndex || 1);

    const response = await apiFetch(url, {
      method: 'POST',
      credentials: 'include',
      body: formData,
      signal,
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }
    return await response.json();
  },

  async getAnalystsTable(filters = {}, signal) {
    const url = `${process.env.REACT_APP_API_URL}/Record/AnalystsTable`;
    const formData = new FormData();
    
    formData.append('GroupId', filters.groupId || 0);
    formData.append('VisorRef', filters.visorRef || '');
    formData.append('ReviewedBy', filters.analystUsername || '');

    if (filters.dateRange?.[0]?.startDate) {
      const fromDate = new Date(filters.dateRange[0].startDate);
      if (filters.startTime) {
        const t = new Date(filters.startTime);
        fromDate.setHours(t.getHours(), t.getMinutes(), t.getSeconds() || 0, t.getMilliseconds() || 0);
      }
      formData.append('FromDate', formatDate(fromDate));
    }

    // Merge dateRange with endTime
    if (filters.dateRange?.[0]?.endDate) {
      const toDate = new Date(filters.dateRange[0].endDate);
      if (filters.endTime) {
        const t = new Date(filters.endTime);
        toDate.setHours(t.getHours(), t.getMinutes(), t.getSeconds() || 0, t.getMilliseconds() || 0);
      }
      formData.append('ToDate', formatDate(toDate));
    }

    formData.append('Positive', filters.positive != null ? String(filters.positive) : '0');
    formData.append('Quarantine', filters.quarantine != null ? String(filters.quarantine) : '0');
    formData.append('Status', filters.status != null ? String(filters.status) : '2');
    formData.append('Action', filters.action != null ? String(filters.action) : '0');
    formData.append('SortColumn', filters.sortColumn || 1);
    formData.append('SortAsc', filters.sortAsc ?? false);    
    formData.append('PageSize', filters.pageSize || 10);
    formData.append('PageIndex', filters.pageIndex || 1);

    const response = await apiFetch(url, {
      method: 'POST',
      credentials: 'include',
      body: formData,
      signal,
    });

    if (!response.ok) {
      throw new Error(`HTTP test error! status: ${response.status}`);
    }
    return await response.json();
  }, 

  async updateRecords(records) {
    const url = `${process.env.REACT_APP_API_URL}/Record/UpdateAll`;

    const response = await apiFetch(url, {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',        
      },
      credentials: 'include',
      body: JSON.stringify(records),
    });

    if (response.status === 204) {
      return;
    }

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    try {
      return await response.json();
    } catch (error) {
      throw new Error('Unexpected response format.');
    }
  },

  async updateRecord(record) {
    const url = `${process.env.REACT_APP_API_URL}/Record/Update`;

    const response = await apiFetch(url, {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',        
      },
      credentials: 'include',
      body: JSON.stringify(record),
    });

    if (response.status === 204) {
      return;
    }

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    try {
      return await response.json();
    } catch (error) {
      throw new Error('Unexpected response format.');
    }
  },

async setImageAsReviewed(imageId) {
  const url = `${process.env.REACT_APP_API_URL}/Record/SetImageAsReviewed?imageId=${encodeURIComponent(imageId)}`;

  const response = await apiFetch(url, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    credentials: 'include'
  });

  if (response.status === 204) {
    return;
  }

  if (!response.ok) {
    throw new Error(`HTTP error! status: ${response.status}`);
  }

  try {
    return await response.json();
  } catch (error) {
    throw new Error('Unexpected response format.');
  }
},

async getRecordsAudit(filters = {}) {
  const baseUrl = `${process.env.REACT_APP_API_URL}/Record/RecordsAudit`;

 const params = new URLSearchParams();

if (filters.reviewer) params.append('Reviewer', filters.reviewer);
if (filters.visorRef) params.append('VisorRef', filters.visorRef);
if (filters.fromDate) params.append('FromDate', filters.fromDate);
if (filters.toDate) params.append('ToDate', filters.toDate);
if (filters.status) params.append('Status', filters.status);
if (filters.positive) params.append('Positive', filters.positive);
if (filters.quarantine) params.append('Quarantine', filters.quarantine);
if (filters.sortColumn) params.append('SortColumn', filters.sortColumn);
if (filters.sortAsc) params.append('SortAsc', filters.sortAsc);
if (filters.pageSize) params.append('PageSize', filters.pageSize);
if (filters.pageIndex) params.append('PageIndex', filters.pageIndex);


  const url = `${baseUrl}?${params.toString()}`;

  const response = await apiFetch(url, {
    method: 'GET',
    credentials: 'include',
  });

  if (!response.ok) {
    throw new Error(`HTTP error! status: ${response.status}`);
  }

  return await response.json();
},

async getRecordsAuditById(imageId = {}) {
  const url = `${process.env.REACT_APP_API_URL}/Record/RecordsAuditById/${encodeURIComponent(imageId)}`;

  const response = await apiFetch(url, {
    method: 'GET',
    credentials: 'include',
  });

  if (!response.ok) {
    throw new Error(`HTTP error! status: ${response.status}`);
  }

  return await response.json();
},

async setAction(recordId, isAction) {
  const url = `${process.env.REACT_APP_API_URL}/Record/SetAction`;

  const response = await apiFetch(url, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    credentials: 'include',
    body: JSON.stringify({ recordId, isAction })
  });

  if (response.status === 204) {
    return;
  }

  if (!response.ok) {
    throw new Error(`HTTP error! status: ${response.status}`);
  }

  try {
    return await response.json();
  } catch (error) {
    throw new Error('Unexpected response format.');
  }
},

  async setActionAll(records) {
    const url = `${process.env.REACT_APP_API_URL}/Record/SetActionAll`;

    const response = await apiFetch(url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',        
      },
      credentials: 'include',
      body: JSON.stringify(records),
    });

    if (response.status === 204) {
      return;
    }

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    try {
      return await response.json();
    } catch (error) {
      throw new Error('Unexpected response format.');
    }
  },

}

export default recordService;
